import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'fieldType' as const;

/**
 * The options of the filter.
 */
export const OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Číslo' },
  { value: 'date', label: 'Dátum' },
  { value: 'select', label: 'Výber' },
  { value: 'predefined', label: 'Preddefinované údaje' },
  { value: 'checkbox', label: 'Zaškrtávacie pole' },
];

/**
 * Parameters of the EvidenceFieldTypeSelectFilter component.
 */
export interface EvidenceFieldTypeSelectFilterProps {
  api: GridApi;
  onChange: FilterChangeCallback;
}

/**
 * Filter component for the fieldType column.
 *
 * This filter assumes:
 * - column field is `fieldType`
 */
export default function EvidenceFieldTypeSelectFilter({ api, onChange }: EvidenceFieldTypeSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <Select
      searchable
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky typy polí"
      data={OPTIONS}
      value={value}
      onChange={setValue}
    />
  );
}
